import React from "react";
import { Row, Col, Button, Form } from "react-bootstrap";
import { Must } from "../SiteCreationComp/Fields";
import { useForm, useFieldArray } from "react-hook-form";
import GYAxios from "../../../util/GYAxios";
import Noti from "../../../util/noti";
import moment from "moment-timezone";
import "./ExtralineForm.css";

const ExtraLineForm = (props) => {
    const siteID = props.site.value.siteID;
    const operationStatus = props.site.value.operation_status;
    const month = moment(props.month).format("YYYY-MM") + '%';
    // const siteID = props.site.siteID;
    // const selectedMonth = props.selectedMonth;
    const secondLanguage = props.site.value.country === 'VN' ? '(vi)' : '(th)';
    const specialComment = props.site.value.specialComment;
    const amount = props.site.value.specialDiscount;

    const formBtnStyle = {
        width: "15%",
        minWidth: "120px",
        margin: "auto",
        marginTop: "40px",
        display: "block",
    };
    const cancelBtnStyle = {
        width: "15%",
        minWidth: "120px",
        margin: "auto",
        marginTop: "40px",
        display: "block",
    };
    const removeBtnStyle = {
        textAlign: "right",
        paddingRight: "20px",
        color: "red",
    };

    const linesObj = specialComment === null ? [{
        descriptionEN: "",
        descriptionVI: "",
        amount: ""
    }] : [{
        descriptionEN: specialComment.split(" / ")[0],
        descriptionVI: specialComment.split(" / ")[1],
        amount
    }];
    const { control, handleSubmit, register } = useForm({ defaultValues: { linesObj } });
    const { fields, append, remove } = useFieldArray({
        control,
        name: "linesObj",
    });

    window.remove = remove;

    const onSubmit = (submittedData) => {
        const confirmSubmit = window.confirm(`Confirm Submit Data?`);
        if (!confirmSubmit) { return }
        const linesObj = submittedData.linesObj;
        const formattedLines = linesObj.map(prepareLine);
        const insertLinesReq = formattedLines.map(insertNewLine);
        Promise.all([...insertLinesReq]).then(responses => {
            const errors = responses.filter((res) => res.data.affectedRows !== 1 && res.data.serverStatus !== 2);
            if (errors.length > 0) {
                return Noti.create({
                    type: "e",
                    msg: "Couldn't add new lines!",
                });
            };
            Noti.create({
                type: "s",
                msg: "Line added successfully!",
            });
            props.closeForm();
            props.ready(false);
        })
    }

    const prepareLine = (_line) => {
        const line = { ..._line };
        line.description = [line.descriptionEN, line.descriptionVI].join(' / ');
        delete line.descriptionEN;
        delete line.descriptionVI;
        let formattedLine = {
            ...line,
            siteID,
            month,
            operationStatus
        }
        return formattedLine;
    }

    const insertNewLine = async (input) => {
        return await GYAxios.post("/invoice/extraline", input);
    }

    // const appendNewLine = () => append(defaultLineObj);

    return (
        <>
            <div className="extraline-heading">
                <Row>
                    <Col sm={12} style={{ textAlign: "right" }}>
                        <span className="glyphicon glyphicon-remove" style={{ cursor: "pointer", fontSize: "28px", color: "#88b917" }} onClick={() => props.closeForm()}>
                        </span>
                    </Col>
                </Row>
                <Row>
                    <Col sm={12} style={{ textAlign: "center" }}>
                        <h3 style={{ fontWeight: 600, color: "black" }}>EXTRA LINE</h3>
                    </Col>
                </Row>
            </div>
            <div className="line-body">
                <Form sm={8} onSubmit={handleSubmit(onSubmit)}>
                    {fields.map((item, index) => (
                        <div className="" key={index}>
                            {/* <Col sm={10} style={{ textAlign: "left" }}>
                                <h4>Extra Line {index + 1}</h4>
                            </Col>
                            <Col md="1" style={removeBtnStyle}>
                                <span
                                    onClick={() => {
                                        remove(index);
                                    }}
                                >
                                    <span className="glyphicon glyphicon-remove"></span>
                                </span>
                            </Col> */}
                            <Row className="top-align">
                                <Col sm={3}>
                                    <Form.Label>Description (en): <Must /></Form.Label></Col>
                                <Col sm={9}>
                                    <input defaultValue={linesObj[index].descriptionEN} maxLength="500" name={`linesObj[${index}].descriptionEN`} type="text" ref={register({ required: "*required" })} />
                                </Col>
                            </Row>
                            <Row className="top-align">
                                <Col sm={3}>
                                    <Form.Label>  {`Description ${secondLanguage}`}: <Must /> </Form.Label>
                                </Col>
                                <Col sm={9}>
                                    <input defaultValue={linesObj[index].descriptionVI} maxLength="500" name={`linesObj[${index}].descriptionVI`} type="text" ref={register({ required: "*required" })} />
                                </Col>
                            </Row>
                            <Row className="center-alignment top-align">
                                <Col sm={3}>
                                    <label> Amount: <Must /> </label>
                                </Col>
                                <Col sm={9}>
                                    <input defaultValue={linesObj[index].amount} step=".01" name={`linesObj[${index}].amount`} type="number" ref={register({ required: "*required" })} />
                                </Col>
                            </Row>
                        </div>
                    ))}
                    {/* <img
                        src={`${directory}/images/add-form2.png`}
                        alt="add line"
                        style={{
                            width: "5%",
                            cursor: "pointer",
                            opacity: "0.5",
                            margin: "auto",
                            display: "block",
                        }}
                        title="Add Line"
                        onClick={appendNewLine}
                    /> */}
                    <Row>
                        <Col md='6'>
                            <Button
                                variant="primary"
                                style={formBtnStyle}
                                type="submit"
                                disabled={fields.length === 0}
                            >
                                Submit
                            </Button>
                        </Col>
                        <Col md='6'>
                            <Button
                                variant="light"
                                style={formBtnStyle}
                                type="cancel"
                                onClick={() => props.closeForm()}
                            >
                                Cancel
                            </Button>
                        </Col>
                    </Row>
                </Form>
            </div>
            <Noti />
        </>
    )
};
export default ExtraLineForm;